<template>
  <div v-if="filePath">
    <v-container>
      <v-row>
        <v-col>
          <v-img v-if="imageFileFormat" class="pa-0 ma-0 py-0" :src="fileUrl" @click="onClick" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <FileInput :label="$t('ELE0209')" :filePath="filePath" />
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="imageDialog" max-width="50%">
      <v-img height="100%" :src="fileUrl" @click="imageDialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import { Storage } from '@/plugins/storage'
import FileInput from '@/components/atoms/file/FileInput'

export default {
  name: 'FileView',

  components: { FileInput },

  props: {
    path: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      imageDialog: false,
      fileUrl: '',
      imageFileFormat: false,
      // 表示させる拡張子
      imageFormats: ['png', 'jpg', 'jpeg'],
    }
  },

  computed: {
    filePath: {
      get() {
        return this.path
      },
    },
  },

  watch: {
    filePath: async function () {
      this.checkFileFormat()
      if (this.imageFileFormat) {
        await this.getFileImage()
      }
    },
  },

  methods: {
    onClick() {
      this.imageDialog = true
    },
    async getFileImage() {
      if (this.filePath) {
        try {
          this.fileUrl = ''
          this.fileUrl = await Storage.getFileUrl(this.filePath)
        } catch (error) {
          this.fileUrl = ''
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0035') })))
        }
      }
    },
    checkFileFormat() {
      // imageFormatsに入っている拡張子かどうかを判別する
      let fileExtension = this.filePath.substr(this.filePath.lastIndexOf('.') + 1)
      fileExtension = fileExtension.toLowerCase()
      if (this.imageFormats.includes(fileExtension)) {
        this.imageFileFormat = true
      } else {
        this.imageFileFormat = false
      }
    },
  },
  async mounted() {
    this.imageFileFormat = false
    this.checkFileFormat()
    if (this.imageFileFormat) {
      await this.getFileImage()
    }
  },
}
</script>
